import React, { Suspense, useEffect } from 'react'
import Hero from './Hero'
import Aboutus from './Aboutus'
import Services from './Services'
import WhyChooseUs from './WhyChooseUs'
import PortfolioCompany from './PortfolioCompany'
import LatestFeatures from './LatestFeatures'
import OurTeam from './OurTeam'

const App = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
        } else {
          entry.target.classList.remove('show');
        }
      });
    });

    setTimeout(() => { // Ensures elements exist before selecting
      const hiddenElements = document.querySelectorAll('.smooth');
      hiddenElements.forEach((el) => observer.observe(el));
    }, 100);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Hero />
      <Aboutus />
      <Services />
      <LatestFeatures />
      <OurTeam />
      <WhyChooseUs />
      <PortfolioCompany />
    </>
  );
};

export default App;
